
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

import DialogColor from './DialogColor';

const classNames = mergeStyleSets({
    root: {

    }
});

const ColorTextBox = ({disabled, label, value, onChange}) => {

    const handleChangeColor = (event) => {
        if (onChange) {
            onChange(event.target.value);
        }
    }

    const handleIconClick = async () => {
        let color = await DialogColor.show(value, {});
        if (color) {
            if (onChange) {
                onChange(color);
            }
        }
    }

    return (
        <div className={classNames.root}>
            <TextField
                disabled={disabled}
                label={label}
                value={value}
                onChange={handleChangeColor}
                iconProps={{
                    iconName: 'Color',
                    style: !disabled
                        ? {
                            pointerEvents: 'auto',
                            cursor: 'pointer'
                        }
                        : null,
                    onClick: handleIconClick,
                  }}
            />
        </div>
    );
}

export default ColorTextBox;
